import { useCallback, useEffect, useState } from 'react';

interface WorkshopAddress {
  firstname: string;
  lastname: string;
  street: string;
  streetnumber: string;
  bus?: string;
  zipcode: string;
  city: string;
  country: string;
  basketId: string;
  timestamp: number;
}

const STORAGE_KEY = 'workshop-address';

export const useWorkshopAddress = (basketId?: string) => {
  const [address, setAddress] = useState<WorkshopAddress | null>(null);

  useEffect(() => {
    if (basketId && typeof window !== 'undefined') {
      const stored = localStorage.getItem(STORAGE_KEY);

      if (stored) {
        try {
          const parsed = JSON.parse(stored);

          // Only use if it matches the current basketId
          if (parsed.basketId === basketId) {
            setAddress(parsed);
          }
        } catch (error) {
          console.error('Failed to get workshop address:', error);
          localStorage.removeItem(STORAGE_KEY);
        }
      }
    }
  }, [basketId]);

  const saveAddress = useCallback((addressData: Omit<WorkshopAddress, 'timestamp'>) => {
    if (typeof window !== 'undefined') {
      const now = Date.now();
      const dataToStore: WorkshopAddress = {
        ...addressData,
        timestamp: now,
      };

      localStorage.setItem(STORAGE_KEY, JSON.stringify(dataToStore));
      setAddress(dataToStore);
    }
  }, []);

  const clearAddress = useCallback(() => {
    if (typeof window !== 'undefined') {
      localStorage.removeItem(STORAGE_KEY);
      setAddress(null);
    }
  }, []);

  return {
    address,
    saveAddress,
    clearAddress,
  };
};

export default useWorkshopAddress;
